const data = [
    {
        "id": 5,
        "title": "EPIDEAA",
        "slug": "epideaa",
        "src": "/assets/video/EPIDEAA animation logo final.mp4",
        "srcSlider": "/assets/img/project/Epideaa/EPIDEAA-website.jpg",
        "category": [
            "Web Design"
        ],
        "description": [
            "EPIDEAA se présente comme le guide idéal pour des vacances aux Maldives, offrant une exploration des trésors naturels de ce paradis terrestre. En tant qu'expert de renom sur cet archipel, il met à la disposition de sa clientèle des services de conseil, de recommandation et de planification d'activités afin de garantir des expériences mémorables et un séjour inoubliable. Les Maldives occupent actuellement une place de choix parmi les 15 destinations les plus prisées à l'échelle mondiale, bénéficiant d'une notoriété considérable. Face à l'affluence de visiteurs et à la multitude de guides disponibles, il est essentiel pour EPIDEAA de se positionner judicieusement dans ce secteur concurrentiel.",
            "Nous avons eu le privilège d'accompagner notre client, EPIDEAA, dans le processus crucial de renforcement de sa visibilité. Ce projet s'est révélé particulièrement gratifiant, car nous avons été chargés de concevoir l'ensemble des supports de communication de l'entreprise. Notre intervention a débuté par la création de l'identité visuelle, englobant la conception dulogotype et de la charte graphique. Ensuite, nous avons élaboré divers supports tels que des brochures, des flyers, des cartes de visite, des roll-ups, ainsi que l’animation du logo (motion design), la réalisation d'une vidéo promotionnelle de l'entreprise, et enfin, le développement du site internet.",
            "Nous avons cherché à mettre en avant la splendeur naturelle des Maldives, incarnée par ses îles et plages, en utilisant les couleurs bleu et blanc. Ces couleurs évoquent également le calme et la sérénité, des valeurs expérientielles cruciales pour les consommateurs en quête de bien-être lors de leur séjour aux Maldives. Pour exprimer le caractère ensoleillé de ces escapades, nous avons intégré une représentation iconique du soleil autour du 'e' dans le nom d'EPIDEAA. Les lignes sinueuses, telles des vagues intégrées au logo, se retrouvent également sur d'autres supports, associées à des photographies des plages et îles, rappelant ainsi la richesse première des Maldives : leur ressource marine. Ces éléments évoquent le dynamisme et le mouvement. EPIDEAA est à la quête de l'excellence au travers des services offerts, pour créer des moments uniques aux Maldives, que nous avons par des cercles, symbolisant la perfection."
        ],
        "skils": "Design du logo, charte graphique, site internet, flyers, Roll-Up, carte de visite, dépliant, stand design",
        "overlay": 1,
        "href": "https://epideaa.com",
        "date": "12-01-2024",
        "video": {
            "poster": "/assets/video/EPIDEAA animation logo final.mp4",
            "loop": true
        },
        "bgVid": "/assets/img/project/Play icon.png",
        "images": [
            "/assets/video/Epideaa_video.mp4",
            "/assets/video/EPIDEAA animation logo final.mp4",
            "/assets/img/project/Epideaa/EPIDEAA LOGO OFFICIAL_PP.jpg",
            "/assets/img/project/Epideaa/EPIDEAA-website.jpg",
            "/assets/img/project/Epideaa/epideaa 1-100.jpg",
            "/assets/img/project/Epideaa/epideaa 2-100.jpg",
            "/assets/img/project/Epideaa/epideaa_brochure.jpg",
            "/assets/img/project/Epideaa/ROLL-UP-Epideaa.jpg",
            "/assets/img/project/Epideaa/VISIT-CARD-EPIDEAA.jpg",
            "/assets/img/project/Epideaa/graphic-charter-epideaa-mock-up.jpg",
            "/assets/img/project/Epideaa/banner-stand-epideaa.jpg",
            "/assets/img/project/Epideaa/Polo-Shirt-epideaa-Mockup.jpg"
        ],
        "isvideo": true,
        "info": {
            "direction": "THEPLUG COM'",
            "client": "EPIPHANIE",
            "design": "THEPLUG COM'"
        }
    },
    {
        "id": 6,
        "title": "Cake By Maman2Noemi",
        "slug": "cake-by-maman2noemi",
        "src": "/assets/img/project/Cake By Maman2noemi/Cakebymaman2noemi_Mock-up-1.jpg",
        "srcSlider": "/assets/img/project/Cake By Maman2noemi/Cake-by-maman2noemi-website.jpg",
        "category": [
            "Web Design"
        ],
        "description": [
            "Etablissement de pâtisserie, spécialisé dans le cake design, Cake by Maman2Noemi conçoit pour chacun de ses clients des gâteaux uniques et personnalisés en fonction des préférences, des thèmes et des occasions particulières, avec des ingrédients choisis de façon très précise et méticuleuse pour un goût et une texture unique.",
            "En modernisant son entreprise, notre cliente aspirait à obtenir une identité visuelle et des supports de communication reflétant au mieux ses valeurs fondamentales, à savoir la sobriété, la chaleur et l'élégance. Il était également essentiel de mettre en avant des éléments tels que la gourmandise, la cuisine, la fraîcheur, tout en préservant une touche de modernité qui soit représentative de l'esprit contemporain de sa pâtisserie.",
            "En répondant aux directives de notre cliente, nous lui avons proposé un logo épuré qui met en avant son expertise et la qualité exceptionnelle de ses produits, en utilisant une image de pâtissière dans un cercle. Son site internet reflète parfaitement son identité visuelle, mettant en lumière sa compétence et ses performances à travers des produits dont les photographies ont été réalisées par ThePlug Com', accompagnées d'avis clients."
        ],
        "skils": "Design du logo, charte graphique, photographie, site internet",
        "overlay": 3,
        "bgVid": "/assets/img/project/Play icon.png",
        "date": "11-15-2023",
        "href": "https://www.maman2noemi.com",
        "images": [
            "/assets/video/Website_Presentation_maman2noemi.mp4",
            "/assets/img/project/Cake By Maman2noemi/Cakebymaman2noemi_Mock-up-1.jpg",
            "/assets/img/project/Cake By Maman2noemi/Cakebymaman2noemi_Mock-up-2.jpg",
            "/assets/img/project/Cake By Maman2noemi/Cake-by-maman2noemi-website.jpg",
            "/assets/img/project/Cake By Maman2noemi/Maman2noemi 1-100.jpg",
            "/assets/img/project/Cake By Maman2noemi/Maman2noemi 2-100.jpg",
            "/assets/img/project/Cake By Maman2noemi/412_400 2.jpg",
            "/assets/img/project/Cake By Maman2noemi/412_400.jpg",
            "/assets/img/project/Cake By Maman2noemi/633_950 3.jpg",
            "/assets/img/project/Cake By Maman2noemi/Cupcake-3.png",
            "/assets/img/project/Cake By Maman2noemi/gallery2.jpg",
            "/assets/img/project/Cake By Maman2noemi/gallery6.jpg",
            "/assets/img/project/Cake By Maman2noemi/gallery7.jpg",
            "/assets/img/project/Cake By Maman2noemi/gallery9.jpg",
            "/assets/img/project/Cake By Maman2noemi/service-3.jpg"
        ],
        "info": {
            "direction": "THEPLUG COM'",
            "design": "THEPLUG COM'",
            "client": "SYVIANNE",
            "photographie": "STEPHANE KAMWA"
        }
    },
    {
        "id": 8,
        "title": "THEPLUG WEDDING",
        "slug": "theplug-wedding",
        "src": "/assets/img/logo/LOGO WEDDING-NOIR.png",
        "srcSlider": "/assets/img/project/THEPLUG WEDDING/THEPLUG-Wedding-Mock-up.jpg",
        "category": [
            "Web Design"
        ],
        "description": [
            "THEPLUG WEDDING est une agence spécialisée dans la capture des moments les plus mémorables des mariages, tant en photographie qu'en vidéo. La mission de l’agence est d'immortaliser les cérémonies officielles qui unissent deux êtres dans la promesse d'un amour et d'une fidélité éternels. Chez THEPLUG WEDDING, l'amour et l'art fusionnent pour exprimer une beauté exceptionnelle.",
            "Cette philosophie transparaît dans la conception de leur site internet, où les photographies et vidéos mettent en lumière un univers harmonieux empreint de joie et de bonheur. Notre objectif dans cette réalisation était de démontrer que la photographie de mariage va au-delà de simples 'clics', mais qu'elle vise à capturer toute la magie d'un moment unique. Cela requiert créativité et une collaboration étroite entre les mariés et le photographe, contribuant à faire ressortir toute la magie de cet instant unique"
        ],
        "skils": "Design du logo, charte graphique, site internet, photographie, vidéographie, carte de visite, identité de marque",
        "overlay": 4,
        "date": "07-15-2023",
        "href": "https://theplug-wedding.com",
        "video": {
            "poster": "/assets/img/logo/LOGO WEDDING-NOIR.png",
            "loop": true
        },
        "bgVid": "/assets/img/project/Play icon.png",
        "images": [
            "/assets/video/theplug wedding website.mp4",
            "/assets/img/project/THEPLUG WEDDING/THEPLUG-Wedding-Mock-up.jpg",
            "/assets/img/logo/LOGO WEDDING-NOIR.png",
            "/assets/img/project/THEPLUG WEDDING/3.jpg",
            "/assets/img/project/THEPLUG WEDDING/Card Stephane.jpg"
        ],
        "isvideo": false,
        "info": {
            "direction": "THEPLUG COM'",
            "design": "THEPLUG COM'",
            "client": "THEPLUG WEDDING",
            "photographie": "STEPHANE KAMWA"
        }
    },
    {
        "id": 10,
        "title": "Pulse Live",
        "slug": "pulse-live",
        "src": "/assets/video/Pulse live animation logo.mp4",
        "srcSlider": "/assets/img/project/Pulse Live/pulselive-Website-1.jpg",
        "category": [
            "Web Design"
        ],
        "description": [
            "PULSE LIVE ENTERTAINMENT établit en Allemagne, se distingue en tant que société spécialisée dans la planification de tournées, la production de concerts, de festivals et de spectacles. Fondée par des enthousiastes de musique, elle s'engageà promouvoir la scène musicale africaine, en mettant l'accent sur l'Allemagne, tout en visant une présence remarquable à l'échelle européenne et mondiale",
            "Dans le but d'accentuer la visibilité et la dynamique de leur travail, l'entreprise nous a contactés pour rédefinir son logo, et travailler à la création de leur site internet. L'objectif était de rendre le logo veritablement représentatif de leur entreprise, en mettant en avant son aspect festif et dynamique, avec une touche de glamour, à travers l'utilisation de couleurs vibrantes et d'éléments animés. Le site internet, quant à lui, met en lumière la musique africaine en mettant en avant des visages qui incarnent parfaitement cette richesse culturelle, contribuant ainsi à sa promotion à l&#39;échelle internationale."
        ],
        "skils": "Design du logo, charte graphique, vidéographie",
        "overlay": 2,
        "date": "01-09-2023",
        "href": "https://www.pulse-live.de",
        "video": {
            "poster": "/assets/video/Pulse live animation logo.mp4",
            "loop": true
        },
        "bgVid": "/assets/img/project/Play icon.png",
        "images": [
            "/assets/video/PULSE LIVE_Website presentation-.mp4",
            "/assets/img/logo/PULSELIVE.png",
            "/assets/img/project/Pulse Live/pulselive-Website.jpg",
            "/assets/img/project/Pulse Live/pulselive-Website-1.jpg",
            "/assets/img/project/Pulse Live/compound-slider.jpg"
        ],
        "isvideo": true,
        "info": {
            "direction": "PULSE LIVE",
            "design": "THEPLUG COM'",
            "client": "PULSE LIVE"
        }
    },
    {
        "id": 11,
        "title": "Esk Translations UG",
        "slug": "esk-translations-ug",
        "src": "/assets/img/logo/EsK_Translations.png",
        "srcSlider": "/assets/img/project/Esk Translations UG/esk-translation-Mock-up.jpg",
        "category": [
            "Web Design"
        ],
        "description": [
            "ESK TRANSLATIONS UG se positionne en tant qu'agence de traduction offrant des services de qualité exceptionnelle aux entreprises internationales, multinationales, ainsi qu'aux particuliers. Elle veille à ce que ses traductions reflètent parfaitement la vision de ses clients, offrant ainsi une expérience enrichissante, captivante et agréable.",
            "L'entreprise avait besoin d'un site vitrine pour exposer ses divers services et mettre en avant les offres d'une agence de traduction allant au-delà de la simple traduction. Le site met en lumière des services tels que le sous-titrage, la rédaction, la relecture des traductions, l'édition, et bien d'autres prestations que vous pouvez explorer en détail sur la plateforme en ligne."
        ],
        "skils": "Design du logo, charte graphique, carte de visite, vidéographie",
        "overlay": 3,
        "bgVid": "/assets/img/project/Play icon.png",
        "date": "10-10-2023",
        "href": "https://www.esk-translations.com",
        "images": [
            "/assets/video/Website_Presentation_ESK translation.mp4",
            "/assets/img/project/Esk Translations UG/esk-translation-Mock-up.jpg",
            "/assets/img/logo/EsK_Translations.png",
            "/assets/img/project/Esk Translations UG/trans.jpg"
        ],
        "info": {
            "direction": "THEPLUG COM'",
            "design": "THEPLUG COM'",
            "client": "ESTELLE KAMWA"
        }
    },
    {
        "id": 14,
        "title": "SAB Afrique",
        "slug": "sab-afrique",
        "src": "/assets/video/Montage_SAB.mp4",
        "srcSlider": "/assets/img/project/SAB Afrique/2024/SABAFRIQUE-Mock-up.jpg",
        "category": [
            "Web Design"
        ],
        "description": [],
        "skils": "Réalisation du site web, vidéographie, montage vidéo, graphic design, photographie",
        "overlay": 2,
        "date": "28-06-2024",
        "href": "https://sabafrique.com/",
        "video": {
            "poster": "/assets/video/Montage_SAB.mp4",
            "loop": true
        },
        "bgVid": "/assets/img/project/Play icon.png",
        "images": [],
        "isvideo": true,
        "info": {
            "direction": "D-FIT",
            "design": "THEPLUG COM'",
            "client": "SAB Afrique",
            "photographie": "THEPLUG COM'",
            "videographie": "THEPLUG COM'"
        }
    },
    {
        "id": 15,
        "title": "Leslie & Daniel",
        "slug": "leslie-et-daniel",
        "src": "/assets/img/project/Leslie&Daniel/Leslie-&-Daniel-website-Mock-up.jpg",
        "srcSlider": "/assets/img/project/Leslie&Daniel/Leslie-&-Daniel-website-Mock-up.jpg",
        "category": [
            "Web Design"
        ],
        "description": [],
        "skils": "Réalisation du site web, gestion numérique des invitations",
        "overlay": 2,
        "date": "20-06-2024",
        "href": "https://leslieetdaniel.fr",
        "images": [],
        "isvideo": false
    },
    {
        "id": 16,
        "title": "ThePlug Wedding Cameroun",
        "slug": "cm-theplug-wedding",
        "src": "/assets/img/project/CM THEPLUG WEDDING/theplug-wedding-CM-website-Mock-up.jpg",
        "srcSlider": "/assets/img/project/CM THEPLUG WEDDING/theplug-wedding-CM-website-Mock-up.jpg",
        "category": [
            "Web Design"
        ],
        "description": [],
        "skils": "Réalisation du site web",
        "overlay": 2,
        "date": "20-06-2024",
        "href": "https://cm.theplug-wedding.com/",
        "images": [],
        "isvideo": false
    },
    {
        "id": 17,
        "title": "ThePlug Communication",
        "slug": "theplugcom",
        "src": "/assets/img/project/COM THEPLUG/Theplug-COM-website-Mock-up.jpg",
        "srcSlider": "/assets/img/project/COM THEPLUG/Theplug-COM-website-Mock-up.jpg",
        "category": [
            "Web Design"
        ],
        "description": [],
        "skils": "Réalisation du site web, Design du logo, charte graphique, cartes de visite, vidéographie, flyers",
        "overlay": 2,
        "date": "01-09-2023",
        "href": "https://www.comtheplug.com",
        "images": [],
        "isvideo": false
    }
];

const isWebCategory = (item) => {
    const cats = Array.isArray(item?.category) ? item.category : (item?.category ? [item.category] : []);
    return cats.some((c) => /web/i.test(c));
};

const webData = data.filter(isWebCategory);

export const getPortfolioData = () => webData;

export const getPortfolioItem = (value, whereName = "id") => {
    return webData.find(item => {
        if (item[whereName] === value) return item;
        return null;
    });
};
export const getPortfolioLink = (item) => {
    if (item)
        return item.slug && '/portfolio/' + item.slug;

    return '';
};
